import { useQuery } from '@tanstack/react-query'

import { queries } from '~/features/partners/utils'

type TOptions = {
  shouldFetch?: boolean
}

type TProps = {
  orgId: string
  options?: TOptions
}

const useGetPartnerConfigByOrgId = ({ orgId, options }: TProps) => {
  const { shouldFetch = true } = options || {}

  return useQuery({
    ...queries.partnerByOrgId(orgId),
    enabled: shouldFetch && !!orgId,
  })
}

export default useGetPartnerConfigByOrgId
